"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MvalNode = void 0;
const constants_1 = require("./constants");
const ExtNode_1 = require("../../json-crdt/extensions/ExtNode");
const constants_2 = require("../constants");
class MvalNode extends ExtNode_1.ExtNode {
    constructor() {
        super(...arguments);
        this.extId = constants_2.ExtensionId.mval;
    }
    name() {
        return constants_1.MNEMONIC;
    }
    view() {
        return this.data.view();
    }
}
exports.MvalNode = MvalNode;
